<div class="loader-wrapper" [class]="'variant-' + variant" [class.compact-loader]="compact" [class.failed-loader]="failed">
  @if (failed) {
    <!-- B7 FAILED state: never leave her on an endless spinner. Say what happened,
         reassure that her input is kept, and offer Retry + a support path. -->
    <div class="loader-failed">
      <div class="failed-icon">
        <svg viewBox="0 0 24 24">
          <path d="M12 9v4"></path>
          <path d="M12 17h.01"></path>
          <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        </svg>
      </div>
      <h1>{{ failedHeading }}</h1>
      <p>{{ failedMessage || failedBody }}</p>
      <button type="button" class="loader-retry" (click)="onRetry()">{{ failedRetry }}</button>
      <div class="tip">{{ failedSupport }}</div>
    </div>
  } @else {
  <span class="sparkle s1"></span>
  <span class="sparkle s2"></span>
  <span class="sparkle s3"></span>

  <div class="progress-container">
    <div class="ring-outer"><div class="ring-dot"></div></div>
    <svg class="progress-ring" viewBox="0 0 130 130">
      <circle class="ring-bg" cx="65" cy="65" r="57.2"></circle>
      <circle class="ring-fill" cx="65" cy="65" r="57.2"></circle>
    </svg>
    <!-- Center glyph. Hidden ONLY on the captured-photo analysis overlay
         (hideCenterIcon), where the eye sat over the user's own photo — every
         other loading screen keeps its center icon. -->
    @if (!hideCenterIcon) {
    <div class="ring-icon">
      @switch (variant) {
        @case ('thankyou') {
          <svg viewBox="0 0 24 24">
            <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
          </svg>
        }
        @case ('almostready') {
          <svg viewBox="0 0 24 24">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
          </svg>
        }
        @default {
          <svg viewBox="0 0 24 24">
            <path d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
            <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"></path>
          </svg>
        }
      }
    </div>
    }
  </div>

  @if (!compact) {
    <h1>{{ heading }}</h1>
    <p>{{ subtitle }}</p>
    @if (tip) {
      <div class="tip">{{ tip }}</div>
    }
  }

  <!-- B7 DELAYED state: past the expected wait, reassure that nothing is lost.
       Shown in compact mode too (the face-analysis overlay is one of the long waits). -->
  @if (delayed) {
    <div class="loader-delayed">{{ delayedNote }}</div>
  }
  }
</div>
